import type { InjectedRouter } from 'react-router';

import { MULTI_ORG } from '../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../helpers/features/featureFlags';
import AuthLogin from '../auth/pages/Login';
import type { RouterProps } from '../../types';

import LoginV2 from './pages/Login';

type LoginRouteSwitchProps = {
  location: RouterProps['location'];
  router: InjectedRouter;
};

/**
 * Page-level switch for `/auth/login`, gated on the `MULTI_ORG` feature flag: it renders `LoginV2` when the flag is
 * enabled and the existing `AuthLogin` page otherwise. react-router v3 injects `location`/`router` into the route
 * component; `AuthLogin` needs both, `LoginV2` needs only `location`.
 */
const LoginRouteSwitch = ({ location, router }: LoginRouteSwitchProps) =>
  (useIsFeatureEnabled(MULTI_ORG)
    ? <LoginV2 location={location} router={router} />
    : <AuthLogin location={location} router={router} />);

export default LoginRouteSwitch;
